import consts from '../consts/const';
export const GET_SUB = 'GET_SUB';
export const GET_CASHOUT = 'GET_CASHOUT';

export const  get_sub = () =>{
  return async (dispatch,getState) =>{
    const userid = getState().authReduse.pid;
    const res= await fetch(`http://${consts.url}/payment/${userid}`,{
       method:'POST',
       headers:{'content-Type':'application/json'},
       body:JSON.stringify({userid})
     });

    const ress = await res.json();


    dispatch({type:'GET_SUB',date:ress.date,plan:ress.plan,price:ress.price})
  }
}


export const  get_cashout = () =>{
  return async (dispatch,getState) =>{
    const userid = getState().authReduse.pid;
    const res= await fetch(`/api/earings/${userid}`);

    const ress = await res.json();

// console.log(ress[0].TotalViews,ress[0].pCount)

    dispatch({type:'GET_CASHOUT',TotalViews:ress[0].TotalViews,pCount:ress[0].pCount})
  }
}

